import { ContactBlockLoans } from './ContactBlock/ContactBlock'
import { View } from './view'

export const ProductLoans = View

export const ContactBlockLoansView = ContactBlockLoans
